import React from "react";
import { SiteHeader } from "../components/layout/SiteHeader";
import { SiteFooter } from "../components/layout/SiteFooter";
import { Container } from "../components/layout/Container";

export function PrivacyPage() {
  return (
    <div className="relative flex min-h-screen w-full flex-col bg-background-dark text-white">
      <SiteHeader />
      <main className="flex-1 pt-28 pb-16">
        <Container>
          <div className="mx-auto max-w-3xl rounded-2xl border border-white/10 bg-white/[0.04] p-8 md:p-12">
            <h1 className="text-4xl font-black">Privacy Policy</h1>
            <p className="mt-2 text-sm text-slate-500">Last updated: June 2026</p>
            <div className="mt-8 space-y-6 text-slate-300 leading-relaxed">
              <section>
                <h2 className="text-lg font-black text-white mb-2">What we collect</h2>
                <p>We collect your name, email address, and the simulation payloads you submit. Simulation data is stored to provide your simulation history and is not shared with third parties.</p>
              </section>
              <section>
                <h2 className="text-lg font-black text-white mb-2">How we use it</h2>
                <p>Your email is used to send OTP verification codes and (optionally) product updates. Simulation data is used solely to power your console and history. We do not sell your data.</p>
              </section>
              <section>
                <h2 className="text-lg font-black text-white mb-2">Cookies</h2>
                <p>We use a single session JWT stored in your browser's localStorage. No third-party tracking cookies are used.</p>
              </section>
              <section>
                <h2 className="text-lg font-black text-white mb-2">Data retention</h2>
                <p>Your simulation history is retained as long as your account is active. You can delete individual simulations from the console at any time.</p>
              </section>
              <section>
                <h2 className="text-lg font-black text-white mb-2">Contact</h2>
                <p>For privacy-related requests, email us at <a href="mailto:contact@feuteuristix.com" className="text-primary hover:underline">contact@feuteuristix.com</a>.</p>
              </section>
            </div>
          </div>
        </Container>
      </main>
      <SiteFooter />
    </div>
  );
}
